import i18n from "@/plugins/vueI18n";

const URL_REGEXP = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
const YOUTUBE_URL_REGEXP = /^(?=.*youtube)(?!.*list)/
const EMAIL_REGEXP = /\S+@\S+\.\S+/;
const NUMBER_REGEXP = /(?=.*[0-9])/;
const CAPITAL_LETTER_REGEXP = /(?=.*[A-Z])/;
const LOWER_LETTER_REGEXP = /(?=.*[a-z])/;
const SYMBOL = /(?=.*[!@#$%^&*])/;

export const ValidationRules = {
  positiveNumber: v => {
    if (v === null) {
      return true;
    }

    if (v !== '' && v !== undefined) {
      return (!isNaN(parseFloat(v)) && v >= 0) || i18n.t('ValidationRules.PositiveNumber');
    }
    return true;
  },
  positiveNumberInRange: (start, end) => {
    return v => {
      if (!isNaN(parseFloat(v)) && v >= start && v <= end) return true;
      return i18n.t('ValidationRules.PositiveNumber');
    };
  },
  required: v => !!v || i18n.t('ValidationRules.Required'),
  url: v => {
    if (v) {
      return v.match(URL_REGEXP) || i18n.t('ValidationRules.Url');
    }

    return true;
  },
  youTubeUrl: v => {
    if (v) {
      return v.match(YOUTUBE_URL_REGEXP) || i18n.t('ValidationRules.Url');
    }

    return true;
  },
  email: v => {
    if (v) {
      return v.match(EMAIL_REGEXP) || i18n.t("ValidationRules.Email");
    }

    return false;
  },
  number: v => {
    if (v) {
      return v.match(NUMBER_REGEXP) || i18n.t("ValidationRules.Number");
    }

    return false;
  },
  capitalLetter: v => {
    if (v) {
      return v.match(CAPITAL_LETTER_REGEXP) || i18n.t("ValidationRules.CapitalLetter");
    }

    return false;
  },
  lowerLetter: v => {
    if (v) {
      return v.match(LOWER_LETTER_REGEXP) || i18n.t("ValidationRules.LowerLetter");
    }

    return false;
  },
  symbol: v => {
    if (v) {
      return v.match(SYMBOL) || i18n.t("ValidationRules.Symbol");
    }

    return false;
  },
  isEqualTo: value => {
    return v => v === value || i18n.t("ValidationRules.IsEqualTo");
  },
  min: length => {
    return v => {
      return (
        (v || "").length >= length ||
        i18n.t("ValidationRules.Min", { length: length })
      );
    };
  },
  max: length => {
    return v => {
      return (
        (v || "").length <= length ||
        i18n.t("ValidationRules.Max", { length: length })
      );
    };
  },
  stringExistsInList: (name: string, list: string[], string: string) => {
    if(list.includes(name)) {
      return i18n.t("ValidationRules.StringExistsInList", { string: string });
    }

    return true;
  }
};
